<template>
	<Dialog
		@send="send()"
		v-model="ui.dialog"
		:loading="ui.sending"
		@cancel="ui.dialog = false"
	>
		<template v-slot:title>
			Importar desde CSV
		</template>

		<template v-slot:subtitle>
			Para realizar la importación debes seleccionar un archivo en formato
			CSV.
		</template>

		<template v-slot:text>
			<v-form
				ref="form"
				lazy-validation
				v-model="ui.valid"
				@submit.prevent="send()"
			>
				<v-row>
					<v-col cols="12">
						<v-file-input
							dense
							outlined
							show-size
							v-model="layout.file"
							:rules="[v.required]"
							label="Seleccionar archivo"
						></v-file-input>
					</v-col>
				</v-row>
			</v-form>
		</template>

		<template v-slot:actions-before>
			<v-btn
				color="default"
				class="elevation-0"
				:loading="ui.downloading"
				@click="templateDownload()"
				:large="$vuetify.breakpoint.smAndDown"
				:block="$vuetify.breakpoint.smAndDown"
			>
				descargar template
			</v-btn>
		</template>
	</Dialog>
</template>

<script>
import axios from "axios";
import { V } from "@/main";
import { EventBus } from "@/main";
import SalesOrder from "@/clas/SalesOrder";
import Dialog from "@/../../GeneralComponents/Dialog";
import Csv from "@/../../GeneralComponents/Class/Csv";

export default {
	components: { Dialog },

	data() {
		return {
			v: V,

			layout: {
				file: null,
			},

			ui: {
				valid: true,

				dialog: false,

				sending: false,

				downloading: false,
			},
		};
	},

	created() {
		EventBus.$on("SalesorderImport", () => {
			this.ui.dialog = true;
		});
	},

	methods: {
		async send() {
			if (this.$refs.form.validate()) {
				try {
					this.ui.sending = true;

					let csv = new Csv();

					let data = await csv.csvToJson(this.layout.file);
					console.log(data);
					let salesorder = new SalesOrder();

					let response = await salesorder.jsonStructurevalidate(data);

					EventBus.$emit(
						"SalesOrderCpturesAssign",
						response.data.data
					);

					this.ui.dialog = false;

					this.$refs.form.reset();
				} catch (e) {
					EventBus.$emit("Error", { error: e, errorsShow: true });
				} finally {
					this.ui.sending = false;
				}
			}
		},

		async templateDownload() {
			try {
				this.ui.downloading = true;

				let csv = new Csv([
					{
						codigo: null,
						cantidad: null,
					},
				]);

				await csv.jsonToCsv();

				csv.csvDownload();
			} catch (e) {
				EventBus.$emit("Error", { error: e, errorsShow: true });
			} finally {
				this.ui.downloading = false;
			}
		},
	},

	computed: {},
};
</script>

<style lang="css" scoped></style>
